import { render, staticRenderFns } from "./r-card-package-panel.vue?vue&type=template&id=34ac2b94"
import script from "./r-card-package-panel.vue?vue&type=script&lang=js"
export * from "./r-card-package-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ac2b94')) {
      api.createRecord('34ac2b94', component.options)
    } else {
      api.reload('34ac2b94', component.options)
    }
    module.hot.accept("./r-card-package-panel.vue?vue&type=template&id=34ac2b94", function () {
      api.rerender('34ac2b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/card-package/r-card-package-panel.vue"
export default component.exports